// DS: C110
/** A plain columned, list of topic links for use with a dropdown/opener */
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiTopic } from '@wix/da-papi-types';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { BiData, ItemClickBiEvent } from '@wix/da-bi/pkg/events';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';

import s from './AllTopicsMenu.scss';

export interface Props {
  allTopics: PapiTopic[];
  className?: string;
}

const AllTopicsMenu: React.FC<Props> = props => {
  const { t } = useTranslation();
  const { allTopics = [], className } = props;

  const allTopicsSorted = allTopics.slice(0);
  allTopicsSorted.sort((a, b) => a.name.localeCompare(b.name));

  const rootClasses = classnames(s['root'], className);
  return (
    <Section id="AllTopicsMenu" className={rootClasses} role="dialog">
      <Heading className={s['title']}>{t('topicListPage.allTopics')}</Heading>
      <nav className={s['menu']}>
        {allTopicsSorted.map((topic, index) => (
          <BiLink
            key={topic.name}
            href={topic.url}
            className={s['link']}
            biData={BiData<ItemClickBiEvent>({
              evid: 100,
              typeid: topic.typeId,
              itemid: topic.itemId,
              rank: index,
              sectionname: 'topTopicViewAll',
            })}
          >
            {topic.name}
          </BiLink>
        ))}
      </nav>
    </Section>
  );
};
AllTopicsMenu.displayName = 'AllTopicsMenuC110';
export default AllTopicsMenu;
